// Store
import { Selector, State, StateContext, Action, Store } from '@ngxs/store';
// Models
import { ProductStateModel, ProductListStateModel } from './model/product-state.model';
import { SetProductList } from './actions/product.actions';
import { Injectable } from '@angular/core';

@State<ProductStateModel>({
	name: 'product',
	defaults: {},
	children: []
})
@Injectable()
export class ProductState {
	constructor(private store: Store) { }

	/**
	 * Get Feature ProductListStateModel.
	 * @param state: ProductStateModel
	 */
	@Selector()
	static getProductList(state: ProductStateModel): ProductListStateModel {
		return state.productList;
	}

	/**
	 * Save the productList section
	 * @param ctx
	 * @param payload
	 */
	@Action(SetProductList)
	SetProductList(ctx: StateContext<ProductStateModel>, { productListStateModel }: SetProductList): any {
		const state = ctx.getState();

		return ctx.patchState({
			...state,
			productList: productListStateModel
		});
	}
}
